import { PortalContext } from "../../../context/Provider";
import React, { useEffect, useContext, useState } from "react";
import { desvinculaSocial } from "../../../context/Actions/paciente/paciente";
import { showModal, hideModal } from "../../../context/Actions/modal/modal";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { GlobalContext } from "../../../../global/context/Provider";
import { getPlatform } from "../../../../global/utils/platformDetector";
import {
  checkBiometricAvailable,
  isBiometricEnabled,
  deleteBiometricCredentials,
} from "../../../../global/services/biometric/biometricService";
import CardTemplate from "../../Genericos/CardTemplate/CardTemplate";
import BotonToggle from "../../Genericos/BotonToggle/BotonToggle";
import GoogleIconReduced from "../../../assets/images/generico/GoogleIconReduced";
import IosIconReduced from "../../../assets/images/generico/IosIconReduced";
import FingerprintIcon from "../../../assets/images/generico/FingerprintIcon";
import "./CardSocial.css";

const CardSocial = ({
  onClickVinculaGoogle,
  desvincularGoogle,
  onClickVinculaApple,
  desvincularApple,
}) => {
  const { pacienteDispatch, modalDispatch, pacienteState } =
    useContext(PortalContext);

  // Cambio de contexto
  const { authState, toasterDispatch } = useContext(GlobalContext);

  const deviceType = getPlatform();
  let config = localStorage.getItem("config");
  let opcGoogle = JSON.parse(config).opcLoginGoogle;
  let opcApple = JSON.parse(config).opcLoginApple;
  let opcFacebook = JSON.parse(config).opcLoginFacebook;

  const [googleVinculado, setGoogleVinculado] = useState(false);
  const [appleVinculado, setAppleVinculado] = useState(false);
  // Estados para biometría
  const [biometricAvailable, setBiometricAvailable] = useState(false);
  const [biometricEnabled, setBiometricEnabled] = useState(false);
  const [biometryTypeName, setBiometryTypeName] = useState("Huella Digital");

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const onClickDesvincularGoogle = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "Desvincular Cuenta de Google",
        texto: "Desea desvincular su Cuenta de Google ?",
        dissmiss: dissmiss,
      },
      [
        {
          text: "Volver",
          clase: "btn-Mensaje b-latex30 rb16m c-latex30",
          accion: dissmiss,
        },
        {
          text: "Desvincular",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: desvinculaGoogle,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const onClickDesvincularApple = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "Desvincular Cuenta de Google",
        texto: "Desea desvincular su Cuenta de Google ?",
        dissmiss: dissmiss,
      },
      [
        {
          text: "Volver",
          clase: "btn-Mensaje b-latex30 rb16m c-latex30",
          accion: dissmiss,
        },
        {
          text: "Desvincular",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: desvinculaApple,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const desvinculaGoogle = () => {
    hideModal()(modalDispatch);
    let red = "GOOGLE";
    setGoogleVinculado(false);
    let token = authState.auth.data.token;
    desvinculaSocial(red, token)(pacienteDispatch);
  };

  const desvinculaApple = () => {
    hideModal()(modalDispatch);
    let red = "APPLE";
    setAppleVinculado(false);
    let token = authState.auth.data.token;
    desvinculaSocial(red, token)(pacienteDispatch);
  };

  // Funciones para biometría
  const onClickDesvincularBiometric = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "Desactivar Autenticación Biométrica",
        texto: `¿Deseas desactivar la autenticación con ${biometryTypeName}? Tendrás que ingresar tu DNI y contraseña la próxima vez.`,
        dissmiss: dissmiss,
      },
      [
        {
          text: "Cancelar",
          clase: "btn-Mensaje b-latex30 rb16m c-latex30",
          accion: dissmiss,
        },
        {
          text: "Desactivar",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: desvinculaBiometric,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const desvinculaBiometric = async () => {
    hideModal()(modalDispatch);
    try {
      await deleteBiometricCredentials();
      setBiometricEnabled(false);
      showToaster(
        {
          texto: "Autenticación biométrica desactivada",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
    } catch (error) {
      showToaster(
        {
          texto: "Error al desactivar la autenticación biométrica",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  const vinculandoGoogle = () => {
    setGoogleVinculado(true);
  };

  const vinculandoApple = () => {
    setAppleVinculado(true);
  };

  //esto lo que hace es volver a dejar donde estaba el toggle si cerre la ventana de vinculacion o dio error.
  useEffect(() => {
    if (desvincularGoogle) {
      setGoogleVinculado(false);
    }
  }, [desvincularGoogle]);

  //esto lo que hace es volver a dejar donde estaba el toggle si cerre la ventana de vinculacion o dio error.
  useEffect(() => {
    if (desvincularApple) {
      setAppleVinculado(false);
    }
  }, [desvincularApple]);

  //me fijo cuando cambia la data si tengo vinculada alguna cuenta.
  useEffect(() => {
    if (
      (pacienteState.paciente.datosActualizados.gmail_id !== "") &
        (pacienteState.paciente.datosActualizados.gmail_id !== undefined) &&
      pacienteState.paciente.datosActualizados.gmail_id !== null
    ) {
      setGoogleVinculado(true);
    }
  }, [pacienteState.paciente.datosActualizados]);

  useEffect(() => {
    if (
      (pacienteState.paciente.datosActualizados.apple_id !== "") &
        (pacienteState.paciente.datosActualizados.apple_id !== undefined) &&
      pacienteState.paciente.datosActualizados.apple_id !== null
    ) {
      setAppleVinculado(true);
    }
  }, [pacienteState.paciente.datosActualizados]);

  // Verificar disponibilidad y estado de biometría
  useEffect(() => {
    const initBiometric = async () => {
      const { isAvailable, biometryType } = await checkBiometricAvailable();
      setBiometricAvailable(isAvailable);

      if (isAvailable) {
        // Determinar el nombre del tipo de biometría
        const typeName =
          biometryType === 1
            ? "Touch ID"
            : biometryType === 2
            ? "Face ID"
            : biometryType === 3
            ? "Huella Digital"
            : "Biometría";
        setBiometryTypeName(typeName);

        // Verificar si está habilitada
        const enabled = await isBiometricEnabled();
        setBiometricEnabled(enabled);
      }
    };

    if (deviceType === "ios" || deviceType === "android") {
      initBiometric();
    }
  }, [deviceType]);

  return (
    <React.Fragment>
      {!opcGoogle && !opcFacebook && !opcApple ? (
        ""
      ) : (
        <CardTemplate
          tituloCard="Ingresa al Portal facilmente"
          tituloBodyCard="Ingresa al Portal más fácil y rápidamente vinculando tus cuentas de redes sociales."
          classTituloBody="ptur-card-perfil-body-social-titulo"
          bodyCard={
            <div className="ptur-card-perfil-body-social">
              {opcGoogle ? (
                <>
                  <div className="ptur-card-perfil-body-social-Redes">
                    <div className="ptur-card-perfil-body-social-columna1-fila2">
                      <h3 className="ptur-card-perfil-body-social-texto rb16m c-grey45">
                        <div style={{ marginRight: 11 }}>
                          <GoogleIconReduced />
                        </div>
                        <div style={{ marginBottom: 5 }}>Cuenta de Google</div>
                      </h3>
                    </div>
                    <div className="ptur-card-perfil-body-social-columna2-fila2">
                      <BotonToggle
                        altStr="Google logo"
                        onClickVinculaGoogle={onClickVinculaGoogle}
                        onClickDesvincularGoogle={onClickDesvincularGoogle}
                        vinculandoGoogle={vinculandoGoogle}
                        googleVinculado={googleVinculado}
                      />
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

              {opcApple ? (
                deviceType === "android" ? (
                  ""
                ) : (
                  <>
                    <div className="ptur-card-perfil-body-social-Redes">
                      <div className="ptur-card-perfil-body-social-columna1-fila3">
                        <h3 className="ptur-card-perfil-body-social-texto rb16m c-grey45">
                          <div style={{ marginRight: 13 }}>
                            <IosIconReduced />
                          </div>
                          <div style={{ marginBottom: 2 }}>Cuenta de Apple</div>
                        </h3>
                      </div>
                      <div className="ptur-card-perfil-body-social-columna2-fila3">
                        <BotonToggle
                          altStr="Apple logo"
                          onClickVinculaApple={onClickVinculaApple}
                          onClickDesvincularApple={onClickDesvincularApple}
                          vinculandoApple={vinculandoApple}
                          appleVinculado={appleVinculado}
                        />
                      </div>
                    </div>
                  </>
                )
              ) : (
                ""
              )}

              {/* Autenticación Biométrica */}
              {biometricAvailable &&
                (deviceType === "ios" || deviceType === "android") && (
                  <>
                    <div className="ptur-card-perfil-body-social-Redes">
                      <div className="ptur-card-perfil-body-social-columna1-fila3">
                        <h3 className="ptur-card-perfil-body-social-texto rb16m c-grey45">
                          <div style={{ marginRight: 11 }}>
                            <FingerprintIcon
                              color="var(--color-grey45)"
                              width={20}
                              height={20}
                            />
                          </div>
                          <div style={{ marginBottom: 2 }}>
                            {biometryTypeName}
                          </div>
                        </h3>
                      </div>
                      <div className="ptur-card-perfil-body-social-columna2-fila3">
                        <BotonToggle
                          altStr="Biometric"
                          onClickVinculaApple={() => {
                            if (!biometricEnabled) {
                              showToaster(
                                {
                                  texto:
                                    "Inicia sesión con tu DNI y contraseña para activar la autenticación biométrica",
                                  tipo: "info",
                                },
                                "centroArriba"
                              )(toasterDispatch);
                            } else {
                              onClickDesvincularBiometric();
                            }
                          }}
                          onClickDesvincularApple={onClickDesvincularBiometric}
                          vinculandoApple={() => {}}
                          appleVinculado={biometricEnabled}
                          biometricVinculado={biometricEnabled}
                        />
                      </div>
                    </div>
                  </>
                )}
            </div>
          }
        />
      )}
    </React.Fragment>
  );
};

export default CardSocial;
